<template>
  <el-dialog :title="$t('equipment.prepayFreight')" custom-class="MyDialog" :visible.sync="isDialogVisiblePay" :close-on-click-modal="false"
    @close="closeProcure2Pay" width="920px">
    <div>
      <div class="purchase-info">
        <div class="textOne">
          <span>{{ $t('equipment.ladingNo') }}{{ payData.ladingNo }}</span>
          <span>{{ $t('purchasing.orderTime') }}：{{ payData.ladingCreateTime }}</span>
        </div>
        <div class="textTwo">
          <span>{{ $t('app.auto_179_71c7a446') }}：{{ $i18n.locale === 'en-US' ? $crmCurrencySymbol() : '' }}<span :style="{ color: 'red' }">{{
            payData.orderAmount
          }}</span>{{ $i18n.locale === 'en-US' ? '' : $crmCurrencySuffix() }}<!-- <span v-if="showFreight">（含运费：{{ $i18n.locale === 'en-US' ? $crmCurrencySymbol() : '' }}{{ freightAmountDisplay }}{{ $i18n.locale === 'en-US' ? '' : $crmCurrencySuffix() }}）</span> -->
          </span>
          <span>{{ $t('app.auto_148_b7220f0c') }}：<span :style="{ color: 'red' }">{{
            payData.receivedAmount
          }}</span></span>
        </div>
      </div>
      <div class="pay-box">
        <el-form label-position="left" label-width="130px" :model="formLabelAlign">
          <el-form-item v-if="isDoubleOrder" :label="$t('purchasing.relatedAgent') + '：'">
            <span>{{ dualCampusName }}</span>
          </el-form-item>
          <el-form-item v-if="isOnline && payData.isPromotePay" :label="$t('purchasing.promoteAccount') + '：'">
            <el-input v-model="formLabelAlign.promoteMoney" @blur="countInputNum(6)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>账户余额：{{ agentAccountObj.promoteAccount || 0 }}</span>
          </el-form-item>
          <el-form-item :label="$t('purchasing.goldAccount') + '：'">
            <el-input v-model="formLabelAlign.totalGoldPayMoney" @blur="countInputNum(4)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ accountLabel }}：{{ agentAccountObj.goldAccount || 0 }}</span>
            <!-- <span>可用金额：{{ agentAccountObj.halfGoldAmount || 0 }}</span> -->
          </el-form-item>
          <el-form-item :label="$t('purchasing.cashAccount') + '：'">
            <el-input v-model="formLabelAlign.accountPayMoney" @blur="countInputNum(2)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ accountLabel }}：{{ agentAccountObj.account || 0 }}</span>
          </el-form-item>
          <el-form-item v-if="showDelivery" :label="$t('purchasing.deliveryVoucherAccount') + '：'">
            <el-input v-model="formLabelAlign.deliveryMoney" @blur="countInputNum(5)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>账户余额：{{ agentAccountObj.deliveryAccount || 0 }}</span>
          </el-form-item>
          <el-form-item v-if="!isDoubleOrder" :label="$t('purchasing.remainingAmount') + '：'">
            <el-input v-model="formLabelAlign.elsePayMoney"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom" v-if="bottomShow">{{ $t('purchasing.paymentMethod') }}：<div @click="choicePayWay('mixue_alipay_code')" class="payway-item">
          <img src="@/assets/images/procure2Pay/zhifubao2.png" alt="" />
          <div v-if="payType == 'mixue_alipay_code'" class="is-choice-payway"></div>
        </div>
        <div @click="choicePayWay('mixue_wechat_code')" class="payway-item">
          <img src="@/assets/images/procure2Pay/weixinzhifu1.png" alt="" />
          <div v-if="payType == 'mixue_wechat_code'" class="is-choice-payway"></div>
        </div>
        <div v-if="!isCallCenter" @click="choicePayWay('bank')" class="payway-item">
          <img class="yin" src="@/assets/images/procure2Pay/transfer.jpg" alt="" />
          <span>{{ $t('app.auto_193_4fec09ce') }}</span>
          <div v-if="payType == 'bank'" class="is-choice-payway"></div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelPay">{{ $t('equipment.cancel') }}</el-button>
      <el-button type="primary" @click="Procure2PayFn">{{ $t('equipment.payment') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  queryAgentAccount,
  queryDualAgentAccount,
  queryLadingPayInfo
} from "@/api/AccountInterface";
import LoginUserHelper from "@/util/LoginUserHelper";
export default {
  data() {
    return {
      formLabelAlign: {
        promoteMoney: 0.0,
        totalGoldPayMoney: 0.0,
        accountPayMoney: 0.0,
        deliveryMoney: 0.0,
        elsePayMoney: 0.0
      },
      agentAccountObj: {},
      payType: "", // 选中的支付方式
      account: 0,
      payWay: 6070001,
      accountPayMoney: 0, //代理商账户付款数
      elsePayMoney: 0, //剩余需要付款数
      deliveryMoney: 0,
      deliveryAccount: 0,
      promoteAccount: 0,
      totalGoldPayMoney: 0,
      totalGoldAccount: 0,
      halfGoldAmount: 0,
      goldAccount: 0,
      procureVoucherAccount: 0,
      isDialogVisiblePay: false,
      payData: {}
    };
  },
  props: {
    orderNo: {
      type: Number | String,
      default: ""
    },
    dialogVisiblePay: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: String,
      default: ""
    },
    bottomShow: {
      default: true
    },
    campusId: {
      type: Number | String,
      default: ""
    },
    dualCampusName:  {
      type: String,
      default: ""
    },
  },
  computed: {
    // 是否是外呼订单
    isCallCenter() {
      return this.orderType == 'callCenter';
    },
    // 是否是双重订单
    isDoubleOrder() {
      return this.orderType == 'doubleOrder';
    },
    // 是否是线上订单
    isOnline() {
      return this.orderType == 'online';
    },
    // 是否是赊货订单
    isCreditOrders() {
      return this.orderType == 'creditorders';
    },
    // 采购量单位
    unitLabel() {
      return this.isCallCenter ? '个' : '台';
    },
    // 金账户/现金账户标签文本
    accountLabel() {
      return this.isDoubleOrder ? this.$t('app.auto_293_be89a148') : this.$t('app.auto_294_7ef954c4');
    },
    // 是否显示提货券
    showDelivery() {
      return !this.isDoubleOrder && !this.isCreditOrders && this.payData.isDeliveryPay && !this.isCallCenter;
    },
    // 运费金额
    freightAmountDisplay() {
      return this.payData.freightAmount ? this.payData.freightAmount : 0;
    }
  },
  watch: {
    orderNo: {
      handler(newVal, oldVal) {
        this.queryOrderInfo();
        this.selectData();
      }
    },
    dialogVisiblePay: {
      handler(newVal, oldVal) {
        this.isDialogVisiblePay = newVal;
      },
      immediate: true
    }
  },
  methods: {
    // 支付
    Procure2PayFn() {
      if (this.formLabelAlign.elsePayMoney > 0 && !this.payType) {
        // 需要支付金额的
        this.$message.error(this.$t('app.auto_295_6e62aa26'));
      } else if (this.formLabelAlign.elsePayMoney <= 0) {
        if (
          this.formLabelAlign.promoteMoney ||
          this.formLabelAlign.accountPayMoney ||
          this.formLabelAlign.totalGoldPayMoney ||
          this.formLabelAlign.deliveryMoney
        ) {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj
          );
        } else {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "submitAndAgentPay"
          );
        }
      } else if (
        this.payType == "bank" &&
        this.formLabelAlign.elsePayMoney > 0
      ) {
        // 对公转账
        this.$emit(
          "bankRransferPay",
          this.formLabelAlign,
          this.payType,
          this.agentAccountObj
        );
      } else {
        if (
          this.formLabelAlign.promoteMoney ||
          this.formLabelAlign.accountPayMoney ||
          this.formLabelAlign.totalGoldPayMoney ||
          this.formLabelAlign.deliveryMoney
        ) {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "submitAndAgentPay"
          );
        } else {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "onlyAgentPay"
          );
        }
      }
    },
    // 处理账户数据
    handleAccountData(data, isDoubleOrder = false) {
      const {
        account,
        halfGoldAmount,
        goldAccount,
        deliveryAccount,
        promoteAccount
      } = data;

      this.account = account || 0;
      this.halfGoldAmount = halfGoldAmount;
      this.totalGoldAccount = halfGoldAmount;
      this.goldAccount = goldAccount;
      this.deliveryAccount = deliveryAccount;
      this.promoteAccount = promoteAccount || 0;
    },

    // 获取代理商账户信息
    async fetchAgentAccount() {
      const { campusId } = LoginUserHelper.getUserInfo();
      const isDoubleOrder = this.orderType == "doubleOrder";
      const queryFn = isDoubleOrder
        ? () => queryDualAgentAccount({ orderNo: this.orderNo })
        : () => queryAgentAccount({ campusId });

      const ret = await queryFn();
      if (ret.code == 0) {
        this.agentAccountObj = ret.data;
        this.handleAccountData(this.agentAccountObj, isDoubleOrder);
      }
    },

    async selectData() {
      await this.fetchAgentAccount();
      this.countInputNum();
    },
    // 计算推广费
    calculatePromoteMoney({ orderAmount, receivedAmount, promoteAccount, isPromotePay }) {
      // 如果不允许使用推广费,则返回0
      if (!isPromotePay) {
        return 0;
      }
      const remaining = orderAmount * 100 - receivedAmount * 100;
      return promoteAccount * 100 > remaining
        ? remaining / 100
        : promoteAccount;
    },

    // 计算金账户（在推广费之后）
    calculateGoldMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldAccount }) {
      const remainingAfterPromote = orderAmount * 100 -
        (receivedAmount * 100 + promoteMoney1 * 100);
      return remainingAfterPromote / 100 > totalGoldAccount
        ? totalGoldAccount
        : remainingAfterPromote / 100;
    },

    // 计算现金账户（在金账户之后）
    calculateAccountMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, account, deliveryMoney1 = 0 }) {
      const deliveryMoneyNum = Number(deliveryMoney1) || 0;
      const remainingAfterGold = orderAmount * 100 -
        receivedAmount * 100 -
        promoteMoney1 * 100 -
        totalGoldPayMoney1 * 100 -
        deliveryMoneyNum * 100;
      const required = remainingAfterGold / 100;
      return account > required ? required : account;
    },

    // 计算提货券（在现金账户之后）
    calculateDeliveryMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1, deliveryAccount }) {
      const elsePayMoneyNum = Number(elsePayMoney1) || 0;
      const remainingAfterCash = orderAmount * 100 -
        (receivedAmount * 100 +
          promoteMoney1 * 100 +
          totalGoldPayMoney1 * 100 +
          accountPayMoney1 * 100 +
          elsePayMoneyNum * 100);
      const required = remainingAfterCash / 100;
      return deliveryAccount > required ? required : deliveryAccount;
    },

    // 计算剩余金额（在所有账户之后）
    calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 }) {
      const totalPaid = receivedAmount * 100 +
        promoteMoney1 * 100 +
        totalGoldPayMoney1 * 100 +
        accountPayMoney1 * 100 +
        deliveryMoney1 * 100;
      return Math.max(0, (orderAmount * 100 - totalPaid) / 100);
    },

    // 根据type计算各账户金额
    calculateByType(type, context) {
      const {
        promoteMoney, accountPayMoney, elsePayMoney,
        totalGoldPayMoney, deliveryMoney, maxPayMoney, totalGoldAccount,
        account, deliveryAccount, promoteAccount, orderAmount, receivedAmount, payData
      } = context;

      // 判断是否允许使用推广费
      const isPromotePay = payData.isPromotePay;
      const hasDelivery = this.orderType != 'doubleOrder' && this.orderType != 'creditorders' && payData.isDeliveryPay;

      // 声明所有需要使用的变量
      let promoteMoney1, accountPayMoney1,
          elsePayMoney1, totalGoldPayMoney1, deliveryMoney1;

      switch (type) {
        case 1: // 裂变奖金账户（移除，保留为兼容）
          promoteMoney1 = this.calculatePromoteMoney({ orderAmount, receivedAmount, promoteAccount, isPromotePay });
          totalGoldPayMoney1 = this.calculateGoldMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldAccount });
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, account });
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 2: // 现金账户
          totalGoldPayMoney1 = totalGoldPayMoney;
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          const deliveryMoneyNum = Number(deliveryMoney) || 0;
          accountPayMoney1 = accountPayMoney;
          // 确保不超出订单金额
          const remainingForAccount = orderAmount * 100 - receivedAmount * 100 -
            promoteMoney1 * 100 - totalGoldPayMoney1 * 100 - deliveryMoneyNum * 100;
          accountPayMoney1 = Math.min(accountPayMoney1 * 100, remainingForAccount) / 100;
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = deliveryMoneyNum;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 3: // 剩余支付金额
          totalGoldPayMoney1 = totalGoldPayMoney;
          accountPayMoney1 = accountPayMoney;
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          elsePayMoney1 = elsePayMoney;
          deliveryMoney1 = hasDelivery ? deliveryMoney : 0;
          break;

        case 4: // 金账户
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          const deliveryMoneyNum4 = Number(deliveryMoney) || 0;
          totalGoldPayMoney1 = totalGoldPayMoney;
          // 确保不超出订单金额
          const remainingForGold = orderAmount - receivedAmount - promoteMoney1 - deliveryMoneyNum4;
          totalGoldPayMoney1 = totalGoldPayMoney1 > remainingForGold ? remainingForGold : totalGoldPayMoney1;
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, account });
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 5: // 提货券
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          const deliveryMoneyNum5 = Number(deliveryMoney) || 0;
          totalGoldPayMoney1 = totalGoldPayMoney;
          const remainingForGold5 = orderAmount - receivedAmount - promoteMoney1 - deliveryMoneyNum5;
          totalGoldPayMoney1 = totalGoldPayMoney1 > remainingForGold5 ? remainingForGold5 : totalGoldPayMoney1;
          accountPayMoney1 = accountPayMoney;
          const remainingForAccount5 = orderAmount - receivedAmount - promoteMoney1 - totalGoldPayMoney1 - deliveryMoneyNum5;
          accountPayMoney1 = accountPayMoney1 > remainingForAccount5 ? remainingForAccount5 : accountPayMoney1;
          if (totalGoldPayMoney1 < 0) totalGoldPayMoney1 = 0;
          if (accountPayMoney1 < 0) accountPayMoney1 = 0;
          if (hasDelivery) {
            const remainingAfterOthers = orderAmount * 100 - receivedAmount * 100 -
              promoteMoney1 * 100 - totalGoldPayMoney1 * 100 - accountPayMoney1 * 100;
            deliveryMoney1 = deliveryMoneyNum5 * 100 > remainingAfterOthers ? remainingAfterOthers / 100 : deliveryMoneyNum5;
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 6: // 推广费账户
          // 如果不允许使用推广费，直接设置为0
          if (!isPromotePay) {
            promoteMoney1 = 0;
          } else {
            // 推广费金额不能大于账户余额，也不能大于剩余待支付金额
            const remaining = orderAmount * 100 - receivedAmount * 100;
            promoteMoney1 = promoteMoney * 100 > promoteAccount * 100
              ? (promoteAccount * 100 > remaining ? remaining : promoteAccount * 100) / 100
              : (promoteMoney * 100 > remaining ? remaining : promoteMoney * 100) / 100;
          }
          totalGoldPayMoney1 = this.calculateGoldMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldAccount });
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, account });
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        default: // 初始化计算
          const remainingDef = orderAmount * 100 - receivedAmount * 100;
          promoteMoney1 = isPromotePay ? Math.min((promoteAccount || 0) * 100, remainingDef) / 100 : 0;
          if (promoteMoney1 < 0) promoteMoney1 = 0;
          totalGoldPayMoney1 = this.calculateGoldMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldAccount });
          if (totalGoldPayMoney1 < 0) totalGoldPayMoney1 = 0;
          const deliveryMoneyNumDef = Number(deliveryMoney) || 0;
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, account, deliveryMoney1: deliveryMoneyNumDef });
          if (hasDelivery) {
            const elsePayMoneyNumDef = Number(elsePayMoney) || 0;
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: elsePayMoneyNumDef, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;
      }

      return { promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1, elsePayMoney1 };
    },
    /**
     * 计算输入金额的数量
     * @param {string} type - 支付类型
     */
    countInputNum(type) {
      const payData = this.payData;
      const { account, maxPayMoney, totalGoldAccount, deliveryAccount, promoteAccount } = this;
      const {
        promoteMoney, accountPayMoney, elsePayMoney,
        totalGoldPayMoney, deliveryMoney
      } = this.formLabelAlign;
      const { orderAmount, receivedAmount } = this.payData;

      // 金账户金额不能大于账户余额
      const goldMoneyLimited = Number(totalGoldPayMoney) > totalGoldAccount
        ? totalGoldAccount
        : Number(totalGoldPayMoney);
      if (goldMoneyLimited !== Number(totalGoldPayMoney)) {
        this.formLabelAlign.totalGoldPayMoney = goldMoneyLimited > 0 ? goldMoneyLimited.toFixed(2) : 0;
      }

      // 提货券金额不能大于账户余额
      const deliveryMoneyLimited = Number(deliveryMoney) > deliveryAccount
        ? deliveryAccount
        : Number(deliveryMoney);
      if (deliveryMoneyLimited !== Number(deliveryMoney)) {
        this.formLabelAlign.deliveryMoney = deliveryMoneyLimited > 0 ? deliveryMoneyLimited.toFixed(2) : 0;
      }

      const context = {
        promoteMoney, accountPayMoney, elsePayMoney,
        totalGoldPayMoney: goldMoneyLimited, deliveryMoney: deliveryMoneyLimited, maxPayMoney, totalGoldAccount,
        account, deliveryAccount, promoteAccount, orderAmount, receivedAmount, payData
      };

      const result = this.calculateByType(type, context);

      // 更新表单数据
      const accountNum = Number(result.accountPayMoney1) || 0;
      const elseNum = Number(result.elsePayMoney1) || 0;
      const goldNum = Number(result.totalGoldPayMoney1) || 0;
      const deliveryNum = Number(result.deliveryMoney1) || 0;
      const promoteNum = Number(result.promoteMoney1) || 0;

      this.formLabelAlign.accountPayMoney =
        accountNum > 0 ? accountNum.toFixed(2) : 0;
      this.formLabelAlign.elsePayMoney =
        elseNum > 0 ? elseNum.toFixed(2) : 0;
      this.formLabelAlign.totalGoldPayMoney =
        goldNum > 0 ? goldNum.toFixed(2) : 0;
      this.formLabelAlign.deliveryMoney =
        deliveryNum > 0 ? deliveryNum.toFixed(2) : 0;
      this.formLabelAlign.promoteMoney =
        promoteNum > 0 ? promoteNum.toFixed(2) : 0;
    },
    // 选中支付方式
    choicePayWay(way) {
      this.payType = way;
    },
    // 取消支付
    cancelPay() {
      // if (this.formLabelAlign.accountPayMoney || this.formLabelAlign.totalGoldPayMoney || this.formLabelAlign.deliveryMoney) {
      //   this.$emit('submitPay', this.formLabelAlign, this.payType, this.agentAccountObj, 'paymentFN');
      // } else {
      //   this.$emit('cancelSubitPay');
      // }
      this.$emit("cancelSubitPay");
    },
    closeProcure2Pay() {
      this.isDialogVisiblePay = false;
      this.$emit("closeProcure2Pay");
    },
    queryOrderInfo() {
      queryLadingPayInfo({ ladingNo: this.orderNo }).then(ret => {
        if (ret.code === 0) {
          this.payData = ret.data;
        }
      })
    }
  },
  mounted() {
    this.queryOrderInfo();
    this.selectData();
  }
};
</script>

<style lang="scss" scoped>
.purchase-info {
  color: #4A83E8;
  background: rgb(232, 243, 254);
  width: 95%;
  height: 80px;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.pay-box {
  margin-left: 20px;

  .el-input {
    text-align: left;
    width: 40%;
    margin-right: 8%;
  }

  span {
    margin-right: 3%;
  }
}

.bottom {
  margin-left: 40px;
  display: flex;

  .payway-item {
    position: relative;
    width: 145px;
    height: 52px;
    border: 1px solid rgb(103, 99, 99);
    margin: 0 20px;
    border-radius: 5px;
    line-height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 117px;
      height: 40px;
    }

    .yin {
      width: 54px;
      height: 34px;
    }

    &:hover {
      cursor: pointer;
    }

    .is-choice-payway {
      position: absolute;
      width: 23px;
      height: 23px;
      background: url("@/assets/images/procure2Pay/cornerMark.png") no-repeat;
      right: 0;
      bottom: 0;
      background-size: 100% 100%;
    }
  }
}

:deep(.el-dialog__footer) {
  border-top: 1px solid #e8e8e8;
  padding: 10px;
}
</style>
